import * as types from './types';
import { sortCredits } from '../../utils/helpers';

const initialState = {
  posting: {},
  loadingPosting: false,
  postingError: false,
  impressions: null,
  loadingImpressions: false,
  impressionsError: false,
  visits: null,
  loadingVisits: false,
  visitsError: false,
  leads: null,
  leadsUnread: null,
  loadingLeads: false,
  leadsError: false,
  postingQuality: {},
  loadingPostingQuality: false,
  postingQualityError: false,
  userIsAuthorized: false,
  loadingAuthorization: true,
  leadsStats: null,
  postingLogs: null,
  isDuplicate: false,
  isPenalized: false,
  postingTips: null,
  loadingTips: false,
  getTipsError: false,
  postingReports: null,
  fetchReportError: false,
  fetchingReports: false,
  hasGlobalCredits: false,
  credits: null,
  publishPostingError: false,
  publishPostingSuccess: false,
  saveTagSuccess: false,
  saveTagError: false,
  hasDesempenoData: false,
  loadingInfoShared: false,
  finishReason: [],
  loadingFinishReason: false,
  loadingSuspendPosting: false,
  recievedSuccessfulResponse: false,
  appliesToI24Full: false,
  postingUnreadLeads: false,
  showUnreadLeadsModal: false,
  postingIds: [],
  loadingSendUnreadLeads: false,
  sendUnreadLeadsMsgSuccess: false,
  sendUnreadLeadsMsgError: false,
  hasUnreadLeadsLoading: false,
  hasUnreadLeadsSuccess: false,
  hasUnreadLeadsError: false,
  hasUnreadLeads: false,
  postingFull: null,
  postingFullLoading: false,
  postingFullError: false,
  postingFullSuccess: false
};

const updateSelectedCredit = (credits, publicationPlanId, branchId) => {
  const updatedCredits = { ...credits };
  if (branchId === 'global') {
    updatedCredits.globalCredits.creditItems.map(c => {
      c.checked = c.publicationPlanId === publicationPlanId;
      return c;
    });
  } else {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < updatedCredits.branchCredits.length; i++) {
      if (parseInt(updatedCredits.branchCredits[i].branchId) === branchId) {
        updatedCredits.branchCredits[i].creditItems.map(c => {
          c.checked = c.publicationPlanId === publicationPlanId;
          return c;
        });
        break;
      }
    }
  }
  return updatedCredits;
};

function desempenoReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POSTING_INFO:
      return {
        ...state,
        postingError: false,
        loadingPosting: true
      };
    case types.GET_POSTING_INFO_COMPLETED:
      return {
        ...state,
        postingError: false,
        loadingPosting: false,
        posting: {
          ...action.payload,
          operationType: action.payload.price_operationtype[0]
            ? action.payload.price_operationtype[0].operationType
            : '',
          amountAndCurrency:
            action.payload.price_operationtype[0] && action.payload.price_operationtype[0].amountAndCurrency[0]
              ? action.payload.price_operationtype[0].amountAndCurrency[0]
              : {}
        },
        hasDesempenoData: true,
        postingInfoToShare: action.payload
      };
    case types.GET_POSTING_INFO_FAILED:
      return {
        ...state,
        postingError: true,
        posting: {},
        loadingPosting: false
      };
    case types.GET_IMPRESSIONS:
      return {
        ...state,
        impressionsError: false,
        loadingImpressions: true
      };
    case types.GET_IMPRESSIONS_COMPLETED:
      return {
        ...state,
        impressionsError: false,
        loadingImpressions: false,
        impressions: action.payload
      };
    case types.GET_IMPRESSIONS_FAILED:
      return {
        ...state,
        impressionsError: true,
        impressions: null,
        loadingImpressions: false
      };
    case types.GET_VISITS:
      return {
        ...state,
        visitsError: false,
        loadingVisits: true
      };
    case types.GET_VISITS_COMPLETED:
      return {
        ...state,
        visitsError: false,
        loadingVisits: false,
        visits: action.payload
      };
    case types.GET_VISITS_FAILED:
      return {
        ...state,
        visitsError: true,
        visits: null,
        loadingVisits: false
      };
    case types.GET_LEADS:
      return {
        ...state,
        leadsError: false,
        loadingLeads: true
      };
    case types.GET_LEADS_COMPLETED:
      return {
        ...state,
        leadsError: false,
        loadingLeads: false,
        leads: action.payload.total,
        leadsUnread: action.payload.unread
      };
    case types.GET_LEADS_FAILED:
      return {
        ...state,
        leadsError: true,
        leads: null,
        loadingLeads: false
      };
    case types.GET_POSTING_QUALITY:
      return {
        ...state,
        postingQualityError: false,
        loadingPostingQuality: true
      };
    case types.GET_POSTING_QUALITY_COMPLETED:
      return {
        ...state,
        postingQualityError: false,
        loadingPostingQuality: false,
        postingQuality: action.payload,
        isDuplicate: action.payload.validations && action.payload.validations.some(v => v.rule_id === 'duplicate'),
        isPenalized:
          action.payload.percentage_correctness &&
          parseInt(action.payload.percentage_correctness) === 0 &&
          action.payload.validations &&
          action.payload.validations.some(v => v.rule_id === 'deployment'),
        isRentedOrSold:
          action.payload.percentage_correctness &&
          parseInt(action.payload.percentage_correctness) === 0 &&
          action.payload.validations &&
          action.payload.validations.some(v => v.rule_id === 'rented_or_sold')
      };
    case types.GET_POSTING_QUALITY_FAILED:
      return {
        ...state,
        postingQualityError: true,
        postingQuality: {},
        loadingPostingQuality: false
      };
    case types.GET_AUTHORIZATION:
      return {
        ...state,
        loadingAuthorization: true
      };
    case types.GET_AUTHORIZATION_COMPLETED:
      return {
        ...state,
        loadingAuthorization: false,
        userIsAuthorized: action.payload
      };
    case types.GET_AUTHORIZATION_FAILED:
      return {
        ...state,
        loadingAuthorization: false,
        userIsAuthorized: false
      };
    case types.GET_LEADS_STATS_COMPLETED:
      return {
        ...state,
        leadsStats: action.payload || null
      };
    case types.GET_POSTING_LOGS_COMPLETED:
      return {
        ...state,
        postingLogs: action.payload || null
      };

    case types.GET_POSTING_TIPS:
      return {
        ...state,
        loadingTips: true,
        getTipsError: false
      };

    case types.GET_POSTING_TIPS_COMPLETED:
      return {
        ...state,
        postingTips: action.payload || null,
        loadingTips: false
      };

    case types.GET_POSTING_TIPS_FAILED:
      return {
        ...state,
        loadingTips: false,
        getTipsError: true
      };

    case types.FETCH_REPORTS:
      return {
        ...state,
        fetchingReports: true,
        fetchReportError: false
      };

    case types.FETCH_REPORTS_COMPLETED:
      return {
        ...state,
        postingReports: action.payload || null,
        fetchingReports: false
      };

    case types.FETCH_REPORTS_FAILED:
      return {
        ...state,
        fetchingReports: false,
        fetchReportError: true
      };

    case types.FETCH_CREDITS:
      return {
        ...state,
        loadingCredits: true,
        errorCredits: false
      };

    case types.FETCH_CREDITS_FAILED:
      return {
        ...state,
        loadingCredits: false,
        errorCredits: true
      };

    case types.FETCH_CREDITS_COMPLETED:
      return {
        ...state,
        credits: sortCredits(action.payload),
        hasGlobalCredits: action.payload.globalCredits !== null,
        loadingCredits: false
      };

    case types.SELECT_CREDIT:
      return {
        ...state,
        credits: updateSelectedCredit(state.credits, action.payload.publicationPlanId, action.payload.branchId)
      };

    case types.PUBLISH_POSTING:
      return {
        ...state,
        publishPostingSuccess: false,
        publishPostingError: false
      };

    case types.PUBLISH_POSTING_COMPLETED:
      return {
        ...state,
        publishPostingSuccess: true
      };

    case types.PUBLISH_POSTING_FAILED:
      return {
        ...state,
        publishPostingError: true
      };

    case types.SAVE_POSTING_TAG:
      return {
        ...state,
        saveTagSuccess: false,
        saveTagError: false
      };

    case types.SAVE_POSTING_TAG_COMPLETED:
      return {
        ...state,
        saveTagSuccess: true
      };

    case types.SAVE_POSTING_TAG_FAILED:
      return {
        ...state,
        saveTagError: true
      };

    case types.UPDATE_POSTING_INFO_COMPLETED:
      return {
        ...state,
        posting: {
          ...action.payload,
          operationType: action.payload.price_operationtype[0]
            ? action.payload.price_operationtype[0].operationType
            : '',
          amountAndCurrency:
            action.payload.price_operationtype[0] && action.payload.price_operationtype[0].amountAndCurrency[0]
              ? action.payload.price_operationtype[0].amountAndCurrency[0]
              : {}
        }
      };
    case types.SAVE_SHARED_PERFORMANCE:
      return {
        ...state,
        hasInfoShared: false,
        infoSharedError: false,
        loadingInfoShared: true
      };
    case types.SAVE_SHARED_PERFORMANCE_COMPLETED:
      return {
        ...state,
        hash: action.payload,
        hasInfoShared: true,
        infoSharedError: false,
        loadingInfoShared: false
      };
    case types.SAVE_SHARED_PERFORMANCE_FAILED:
      return {
        ...state,
        hasInfoShared: false,
        infoSharedError: true,
        loadingInfoShared: false
      };

    case types.GET_FINISH_REASON:
      return {
        ...state,
        loadingFinishReason: true
      };
    case types.GET_FINISH_REASON_COMPLETED:
      return {
        ...state,
        finishReason: action.payload || [],
        loadingFinishReason: false
      };
    case types.GET_FINISH_REASON_FAILED:
      return {
        ...state,
        loadingFinishReason: false,
        finishReasonError: true
      };

    case types.SUSPEND_POSTING:
      return {
        ...state,
        loadingSuspendPosting: true,
        fetchedSuspendPosting: false,
        recievedSuccessfulResponse: false
      };
    case types.SUSPEND_POSTING_COMPLETED:
      return {
        ...state,
        loadingSuspendPosting: false,
        fetchedSuspendPosting: true,
        suspendSuccessful: action.payload.successfulPostings || 0,
        recievedSuccessfulResponse: true
      };
    case types.SUSPEND_POSTING_FAILED:
      return {
        ...state,
        loadingSuspendPosting: false,
        fetchedSuspendPosting: true,
        suspendError: true,
        recievedSuccessfulResponse: false
      };

    case types.SHOW_UNREAD_LEADS_MODAL:
      return {
        ...state,
        showUnreadLeadsModal: action.payload.showUnreadLeadsModal,
        postingIds: action.payload.postingIds
      };

    case types.SEND_UNREAD_LEADS_MSG:
      return {
        ...state,
        loadingSendUnreadLeads: true,
        sendUnreadLeadsMsgSuccess: false,
        sendUnreadLeadsMsgError: false
      };
    case types.SEND_UNREAD_LEADS_MSG_COMPLETED:
      return {
        ...state,
        loadingSendUnreadLeads: false,
        sendUnreadLeadsMsgSuccess: true
      };
    case types.SEND_UNREAD_LEADS_MSG_FAILED:
      return {
        ...state,
        loadingSendUnreadLeads: false,
        sendUnreadLeadsMsgError: true
      };

    case types.HAS_UNREAD_LEADS:
      return {
        ...state,
        hasUnreadLeadsLoading: true,
        hasUnreadLeadsSuccess: false,
        hasUnreadLeadsError: false
      };
    case types.HAS_UNREAD_LEADS_COMPLETED:
      return {
        ...state,
        hasUnreadLeadsLoading: false,
        hasUnreadLeads: action.payload,
        hasUnreadLeadsSuccess: true
      };
    case types.HAS_UNREAD_LEADS_FAILED:
      return {
        ...state,
        hasUnreadLeadsLoading: false,
        hasUnreadLeadsError: true
      };

    case types.POSTING_FULL_INFO:
      return {
        ...state,
        postingFullLoading: true,
        postingFullSuccess: false,
        postingFullError: false
      };
    case types.POSTING_FULL_INFO_COMPLETED:
      return {
        ...state,
        postingFullLoading: false,
        postingFull: action.payload,
        postingFullSuccess: true
      };
    case types.POSTING_FULL_INFO_FAILED:
      return {
        ...state,
        postingFullLoading: false,
        postingFullError: true
      };

    default:
      return state;
  }
}

export { desempenoReducer };
